import { get, post, put, del } from './client.js';
import type { ContactSubmission, FollowUpReminder, CreateReminderRequest, UpdateReminderRequest } from '../types/index.js';

export const contactApi = {
  list: (params?: { page?: number; per_page?: number }) => {
    const q = new URLSearchParams();
    if (params?.page) q.append('page', params.page.toString());
    if (params?.per_page) q.append('per_page', params.per_page.toString());
    const qs = q.toString();
    return get<{ data: ContactSubmission[]; pagination: { page: number; per_page: number; total: number } }>(
      `/contacts${qs ? '?' + qs : ''}`
    );
  },
};

export const followUpApi = {
  list: (params?: { is_completed?: number | null; customer_id?: number }) => {
    const query = new URLSearchParams();
    if (params?.is_completed !== undefined && params?.is_completed !== null) query.append('is_completed', String(params.is_completed));
    if (params?.customer_id) query.append('customer_id', String(params.customer_id));
    const qs = query.toString();
    return get<{ data: FollowUpReminder[] }>(`/follow-up-reminders${qs ? '?' + qs : ''}`);
  },

  create: (data: CreateReminderRequest) =>
    post<FollowUpReminder>('/follow-up-reminders', data),

  update: (id: number, data: UpdateReminderRequest) =>
    put<FollowUpReminder>(`/follow-up-reminders/${id}`, data),

  delete: (id: number) =>
    del<{ message: string }>(`/follow-up-reminders/${id}`),
};
